import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./assets/klass.VuwField";

/**
 * VuwRadioField (extends VuwField)
 * @options
 * - {Boolean} required
 * - {Array | Object} dataOption
 */
vuwer.appendKlass("VuwRadioField", {
	inpType: "radio",
	inpClassList: ["inp", "inp-radio"],
	dataOption: null,		// required
	
	_initialize: function _initialize(opt) {
		if( Klass("VuwRadioField").parent._initialize.call(this, opt) ) {
			if( !this.dataOption ||
					( !Array.isArray(this.dataOption) && !u_.isObject(this.dataOption) ) ) {
				this.dataOption = [];
			}
			
			// [バリデーションの登録]
			// 必須
			this.addValidation("required", function(val) {
				return !this.required || !!val || val === 0;
			}, "いずれかを選択して下さい");
			
			// [required, disabled の動的な切り替え用]
			this.onChangeState(function(state) {
				if( state.hasOwnProperty("required") ) {
					this.required = !!state.required;
					delete state.required;
				}
				
				if( state.hasOwnProperty("disabled") ) {
					if(this.$inp.length) {
						if( Array.isArray(state.disabled) ) {
							this.$inp.each(function() {
								var $this = $(this);
								$this.prop("disabled", state.disabled.indexOf(this.value) >= 0);
							});
						} else
						if( typeof state.disabled === "boolean") {
							this.$inp.prop("disabled", state.disabled);
						}
					}
					delete state.disabled;
				}
			});
			
			return this;
		} else {
			return false;
		}
	},
	
	getInpReady: function getInpReady($self) {
		if(this.inpClassList.length > 1) {
			this.$inp = this.$self.find("." + this.inpClassList[1]);
		}
		if(this.$inp.length) {
			this.$self.on("change.setVal", "." + this.inpClassList[1], function(e, isTrigger) {
				!isTrigger && $.data(e.delegateTarget, "vuw").setVal(this.value, this.checked, true);
			});
			
			this.$inp.each( (function(i, elm) {
				$.data(elm, "vuwField", this);
			}).bind(this) );
			
			this.clearVal();
		}
		return this;
	},
	
	getInpElm: function getInpElm(value) {
		var $elm, idStr;
		if( u_.isNumber(value) ) {
			$elm = !!this.$inp.length ? this.$inp.eq(value) : this.$inp;
		} else
		if( value && u_.isString(value) ) {
			idStr = "#" + ["inp", this.idStr, value].join("_");
			$elm = $(idStr);
			if(!$elm.length) {
				$elm = this.$self.find(idStr);
			}
		} else {
			$elm = {
				length: 0
			};
		}
		
		return $elm;
	},
	
	setVal: function setVal(value, isChecked, antiTriggerChange) {
		var $inp, $trigger;
		
		(typeof isChecked === "boolean") || (isChecked = true);
		
		if(isChecked) {
			if(this.$inp.length && !antiTriggerChange) {
				$inp = this.getInpElm(value);
				!$inp.length && ( $inp = this.$inp.eq(0) );
				value = $inp.prop("checked", true).val();
				$trigger = $inp;
			}
			
			Klass("VuwRadioField").parent.setVal.call(this, value);
			
			!!$trigger && $trigger.trigger("change", [true]);
		}
		return this;
	},
	
	getVal: function getVal() {
		var val = Klass("VuwRadioField").parent.getVal.call(this);
		if( Array.isArray(this.dataOption) ) {
			val = parseInt(val);
			isNaN(val) && (val = undefined);
		}
		return val;
	},
	
	_getCopiedInp: function _getCopiedInp(val) {
		var $lbl, clones = [];
		
		(val === undefined) && ( val = this.getVal() );
		
		if(val !== undefined) {
			$lbl = this.$self.find("input[value='" + val + "']").next("label");
			!!$lbl.length && clones.push( $("<fieldset/>").append(
				$lbl.clone().addClass("replaced-inp").attr({
					"for": "",
					"data-value": val
				})
			) );
		}
		return clones;
	},
	
	_renderField: function _renderField() {
		var
			clsList = this.inpClassList.join(" "),
			isArr = Array.isArray(this.dataOption),
			arr = isArr ? this.dataOption : Object.keys(this.dataOption),
			$field = $("<div/>").addClass("vuw-field field-" + this.inpType).attr({
				"id": ["field", this.idStr].join("_"),
				"data-name": this.paramKey
			});
		
		return $field.append.apply( $field, arr.map(function(k, i) {
			var
				val = isArr ? String(i) : k,
				inpId = ["inp", this.idStr, val].join("_");
			
			return $("<fieldset/>").append(
				$("<input/>").addClass(clsList).attr({
					type: this.inpType,
					name: this.paramKey,
					id: inpId
				}).val(val),
				$("<label/>").attr("for", inpId).addClass("hover-target").html( $.parseHTML(isArr ? k : this.dataOption[k]) )
			);
		}, this) );
	}
}, "VuwField");
